import React from 'react';

export function Depilation() {
  return (
    <div className="space-y-4">
      <div className="bg-primary rounded-lg p-4 text-center h-[50px] flex items-center justify-center">
        <h1 className="text-xl text-white">DEPILACIÓN</h1>
      </div>
      <div className="grid grid-cols-1 gap-4">
        <div className="bg-white rounded-lg shadow-md">
          <div className="p-6 space-y-4">
            <h2 className="text-lg font-semibold text-primary">Zonas Faciales</h2>
            <p className="text-gray-600">
              <strong>Cejas:</strong> 5-7€<br />
              <strong>Labio superior:</strong> 3€<br />
              <strong>Mentón:</strong> 3€<br />
              <strong>Facial:</strong> 6€<br />
              <strong>Decoloración:</strong> Consultar
            </p>
            <a 
              href="https://api.whatsapp.com/send?phone=+34654261502&text=Hola%20Sandra!" 
              className="block mt-4 bg-primary text-white text-center px-4 py-2 rounded-full hover:bg-primary/90 transition-colors font-medium"
            >
              CITA PREVIA
            </a>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-md">
          <div className="p-6 space-y-4">
            <h2 className="text-lg font-semibold text-primary">Zonas Corporales</h2>
            <p className="text-gray-600">
              <strong>Piernas enteras:</strong> 16€<br />
              <strong>Medias piernas:</strong> 8€<br />
              <strong>Ingles:</strong> 8-12€<br />
              <strong>Integral:</strong> 16€<br />
              <strong>Interglúteos:</strong> 4€<br />
              <strong>Integral + interglúteos:</strong> 18€<br />
              <strong>Axilas:</strong> 5-7€<br />
              <strong>Brazos:</strong> 10-15€<br />
              <strong>Glúteos:</strong> 6€<br />
              <strong>Lumbares:</strong> 5€<br />
              <strong>Línea alba:</strong> 3€
            </p>
            <a 
              href="https://api.whatsapp.com/send?phone=+34654261502&text=Hola%20Sandra!" 
              className="block mt-4 bg-primary text-white text-center px-4 py-2 rounded-full hover:bg-primary/90 transition-colors font-medium"
            >
              CITA PREVIA
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}